/**
 * App — Root component with all providers.
 * Router is set up in main.tsx.
 *
 * TelemetryProvider wraps the entire app to capture errors and events
 * from the very first render. It checks GET /telemetry/config on mount
 * and only activates collection if the user's org has telemetry enabled.
 */

import { AppRoutes } from '@/routes/routes';
import { TelemetryProvider } from '@/lib/telemetry';

export default function App() {
  return (
    <TelemetryProvider>
      <AppRoutes />
    </TelemetryProvider>
  );
}